<template>
   <div>
     <div class="sl-title-content" :class="color">
        <img  class="icon-title" :src="'./img/icons/sl/logo_'+type+'.png'" alt="..."/>  {{ title }} 
      </div>
      <div class="sl-title-content-separation"></div>
   </div>
</template>
<script>
  export default {
    name: 'title-sl', 
    props: {
        type:String,
        title:String,
        color:String
    }
  };
</script>
